import ModalForm from "./Form";
import { INVOICE_OVERDUE, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "INVOICE-OVERDUE-table",
			rowData: {},
			formId: "INVOICE-OVERDUE-form",
			tableColumns: [
				{
					title: "CLC ID Number",
					type: "custom-html",
					key: "clc_id_number",
					isVisible: true,
					modifier: (value) => {
						return value ? value : '-'
					},
				},
				{
					title: "Inv Req No",
					type: "custom-html",
					key: "request_no",
					isVisible: true,
					modifier: (value) => {
						return value ? value : '-'
					},
				},
				{
					title: "Inv No",
					type: "custom-html",
					key: "invoice_no",
					isVisible: true,
					modifier: (value) => {
						return value ? value : '-'
					},
				},
				{
					title: "Send To",
					type: "custom-html",
					key: "request_send_to",
					isVisible: true,
					modifier: (value) => {
						return value ? value.name + '(' + value.contact + ')' : '-'
					},
				},
				{
					title: "Due Date",
					type: "custom-html",
					key: "due_date",
					isVisible: true,
					modifier: (value) => {
						return value ? value : '-'
					},
				},
				{
					title: "Status",
					type: "custom-html",
					key: "status",
					isVisible: true,
					modifier: (value) => {
						if (value) {
							let ClassName = "danger";

							if (value === "Requested")
								ClassName = `warning`;
							else if (value === "Processed")
								ClassName = `secondary`;
							else if (value === "Invoiced")
								ClassName = `primary`;
							else if (value === "Paid")
								ClassName = `success`;
							else if (value === "Cancelled" || value === "Deleted")
								ClassName = `danger`;

							return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
								value
							)}</span>`;
						}
					},
				},
			],
			ENDPOINT: INVOICE_OVERDUE,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "INVOICE_OVERDUE",
				url: INVOICE_OVERDUE,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "INVOICE-OVERDUE-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
